<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>How to best use Daily Digest?</h1>
        </template>

        <p>Daily Digest is your low-priority inbox that holds all incoming emails from people you've never sent an email to. Reviewing them teaches Mailman how to handle future emails from them.</p>
        
        <ul class="mt-2 text-sm">
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">Deliver Always...</span></div>
               <div class="w-3/4"><span>Send future emails to your primary inbox. This action can be undone later.</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">Block...</span></div>
               <div class="w-3/4"><span>Send future emails to a hidden folder "Blocked by Mailman". Thus, they are always searchable but not visible in your primary inbox. This action can be undone later.</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">Deliver Once</span></div>
               <div class="w-3/4"><span>Send just this one email to your inbox for now, and continue to hold future emails for review.</span></div>
            </li>
            <li class="flex items-center py-2 border-b border-gray-light">
               <div class="w-1/4"><span class="bg-primary-lighter rounded p-1 text-sm font-bold">Mark as reviewed</span></div>
               <div class="w-3/4"><span>Ignore for now, and continue to hold future emails for review.</span></div>
            </li>
        </ul>

        <template v-slot:footer>
            <button class="py-2 px-4 rounded-md bg-primary-lightest" @click="close">Got it.</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>